import { getExistingAddressLine } from '../../utils/Helper';
import * as commonConsts from '../../pages/common/CommonConsts';

const getApplicationDetails = (individualLicence, twoFA, individualAuthorityHolder) => {
  const { twoFaVerified, data } = twoFA;
  const { licenceInfo } = individualLicence;
  const partyRowId = licenceInfo.partyRowId;

  const firstName = twoFaVerified
    ? data?.firstName
    : individualLicence && individualLicence.firstName
    ? individualLicence.firstName
    : '';

  const middleName = twoFaVerified
    ? data?.middleName
    : individualLicence && individualLicence.middleName
    ? individualLicence.middleName
    : '';

  const lastName = twoFaVerified
    ? data?.lastName
    : individualLicence && individualLicence.lastName
    ? individualLicence.lastName
    : '';

  const dateOfBirth = twoFaVerified
    ? data?.day
      ? // ? data?.day + '/' + data?.month + '/' + data?.year
        data?.year + '-' + data?.month + '-' + data?.day
      : null
    : individualLicence && individualLicence.dob
    ? individualLicence.dob
    : null;

  const authorityHolderName = middleName ? `${firstName} ${middleName} ${lastName}` : `${firstName} ${lastName}`;

  const emailAddress = individualAuthorityHolder?.emailAddress
    ? individualAuthorityHolder.emailAddress
    : twoFaVerified
    ? data?.emailAddress
    : individualLicence && individualLicence.email
    ? individualLicence.email
    : null;

  const mobile = individualAuthorityHolder?.mobileNumber
    ? individualAuthorityHolder.mobileNumber
    : twoFaVerified
    ? data?.mobileNumber
    : individualLicence && individualLicence.mobile
    ? individualLicence.mobile
    : null;

  const secondaryContact =
    individualAuthorityHolder && individualAuthorityHolder.secondaryContact
      ? {
          prefix: individualAuthorityHolder.secondaryContact.prefix,
          number: individualAuthorityHolder.secondaryContact.number
        }
      : twoFaVerified
      ? {
          prefix: data?.phoneNumber
            ? data?.phoneNumber.split('-').length > 1
              ? data?.phoneNumber.split('-')[0]
              : null
            : null,
          number: data?.phoneNumber
            ? data?.phoneNumber.split('-').length > 1
              ? data?.phoneNumber.split('-')[1]
              : null
            : null
        }
      : {
          prefix: null,
          number: null
        };

  const residentialAddress = individualAuthorityHolder?.residentialAddress
    ? { ...individualAuthorityHolder.residentialAddress }
    : {};

  //const residentialAddressExisting = individualAuthorityHolder?.residentialAddressExisting;

  const postalAddress = individualAuthorityHolder?.postalAddress ? { ...individualAuthorityHolder.postalAddress } : {};

  //const postalAddressExisting = individualAuthorityHolder?.postalAddressExisting;

  return {
    partyRowId,
    firstName,
    middleName,
    lastName,
    dateOfBirth,
    authorityHolderName,
    emailAddress,
    mobile,
    secondaryContact,
    residentialAddress,
    //residentialAddressExisting,
    postalAddress
    //postalAddressExisting
  };
};

const getOrgApplicationDetails = (validationContactInformation, twoFA, organisationPersonalDetail) => {
  const { twoFaVerified, data } = twoFA;
  const partyRowId = validationContactInformation.partyRowId;

  const firstName = twoFaVerified
    ? data?.firstName
    : validationContactInformation && validationContactInformation.firstName
    ? validationContactInformation.firstName
    : '';

  const middleName = twoFaVerified
    ? data?.middleName
    : validationContactInformation && validationContactInformation.middleName
    ? validationContactInformation.middleName
    : '';

  const lastName = twoFaVerified
    ? data?.lastName
    : validationContactInformation && validationContactInformation.lastName
    ? validationContactInformation.lastName
    : '';

  const dateOfBirth = twoFaVerified
    ? data?.day
      ? data?.day + '/' + data?.month + '/' + data?.year
      : null
    : validationContactInformation && validationContactInformation.dob
    ? validationContactInformation.dob
    : null;

  const authorityHolderName = middleName ? `${firstName} ${middleName} ${lastName}` : `${firstName} ${lastName}`;

  const emailAddress = organisationPersonalDetail?.emailAddress
    ? organisationPersonalDetail.emailAddress
    : twoFaVerified
    ? data?.emailAddress
    : validationContactInformation && validationContactInformation.email
    ? validationContactInformation.email
    : null;

  const mobile = organisationPersonalDetail?.mobileNumber
    ? organisationPersonalDetail.mobileNumber
    : twoFaVerified
    ? data?.mobileNumber
    : validationContactInformation && validationContactInformation.mobile
    ? validationContactInformation.mobile
    : null;

  const secondaryContact =
    organisationPersonalDetail && organisationPersonalDetail.secondaryContact
      ? {
          prefix: organisationPersonalDetail.secondaryContact.prefix,
          number: organisationPersonalDetail.secondaryContact.number
        }
      : twoFaVerified
      ? {
          prefix: data?.phoneNumber
            ? data?.phoneNumber.split('-').length > 1
              ? data?.phoneNumber.split('-')[0]
              : null
            : null,
          number: data?.phoneNumber
            ? data?.phoneNumber.split('-').length > 1
              ? data?.phoneNumber.split('-')[1]
              : null
            : null
        }
      : {
          prefix: null,
          number: null
        };

  const residentialAddress = organisationPersonalDetail?.residentialAddress
    ? { ...organisationPersonalDetail.residentialAddress }
    : {};

  const postalAddress = organisationPersonalDetail?.postalAddress
    ? { ...organisationPersonalDetail.postalAddress }
    : {};

  return {
    partyRowId,
    firstName,
    middleName,
    lastName,
    dateOfBirth,
    authorityHolderName,
    emailAddress,
    mobile,
    secondaryContact,
    residentialAddress,
    postalAddress
  };
};

const getOrgAuthorityHolderDetails = (
  organisationAuthorityHolder,
  organisationLicence,
  validationContactInformation,
  twoFA
) => {
  const { orgDataInfo } = organisationLicence || { orgDataInfo: null };
  const { data, searchCriteria } = orgDataInfo || { data: null, searchCriteria: null };
  const twoFaData = twoFA && twoFA.data ? twoFA.data : null;

  const addressRegisteredOfficePlaceHolder =
    organisationAuthorityHolder &&
    organisationAuthorityHolder?.address &&
    organisationAuthorityHolder?.address?.addresses
      ? getExistingAddressLine(organisationAuthorityHolder?.address?.addresses, 'Registered Office')
      : null;

  const addressBusinessPlaceholder =
    organisationAuthorityHolder &&
    organisationAuthorityHolder?.address &&
    organisationAuthorityHolder?.address?.addresses
      ? getExistingAddressLine(organisationAuthorityHolder?.address?.addresses, 'Business')
      : null;

  const addressPostalPlaceholder =
    organisationAuthorityHolder &&
    organisationAuthorityHolder?.address &&
    organisationAuthorityHolder?.address?.addresses
      ? getExistingAddressLine(organisationAuthorityHolder?.address?.addresses, 'Postal')
      : null;

  let result = {
    authorityHolderName: data && data.entityName ? data.entityName : null,
    abn: data && data?.abn ? data?.abn : null,
    acn: data && data?.acn ? data?.acn : null,
    primaryContact:
      organisationAuthorityHolder && organisationAuthorityHolder?.primaryContact
        ? organisationAuthorityHolder.primaryContact
        : twoFA?.twoFaVerified
        ? twoFaData?.middleName
          ? `${twoFaData.firstName} ${twoFaData.middleName} ${twoFaData.lastName}`
          : `${twoFaData.firstName} ${twoFaData.lastName}`
        : validationContactInformation?.middleName
        ? `${validationContactInformation.firstName} ${validationContactInformation.middleName} ${validationContactInformation.lastName}`
        : `${validationContactInformation.firstName} ${validationContactInformation.lastName}`,
    registeredAcnc: organisationAuthorityHolder?.registeredAcnc,
    isRegisteredAcnc: organisationAuthorityHolder?.isRegisteredAcnc,
    isRegisteredAcncSelected: organisationAuthorityHolder?.isRegisteredAcncSelected,
    organisationType:
      organisationAuthorityHolder && organisationAuthorityHolder?.organisationType
        ? organisationAuthorityHolder?.organisationType
        : organisationAuthorityHolder?.organisationDetail?.organisationType
        ? organisationAuthorityHolder?.organisationDetail?.organisationType
        : null,
    sameAsRegisteredOffice:
      organisationAuthorityHolder && organisationAuthorityHolder.sameAsRegisteredOffice
        ? organisationAuthorityHolder.sameAsRegisteredOffice
        : [addressBusinessPlaceholder ? false : true, addressPostalPlaceholder ? false : true],
    otherAddresses:
      organisationAuthorityHolder && organisationAuthorityHolder.otherAddresses
        ? [...organisationAuthorityHolder.otherAddresses]
        : [],
    addressRegisteredOfficeValue:
      organisationAuthorityHolder && organisationAuthorityHolder.addressRegisteredOfficeValue
        ? { ...organisationAuthorityHolder.addressRegisteredOfficeValue }
        : {},
    registrationNumber:
      organisationAuthorityHolder && organisationAuthorityHolder?.registrationNumber
        ? organisationAuthorityHolder.registrationNumber
        : null,
    registrationName:
      organisationAuthorityHolder && organisationAuthorityHolder?.registrationName
        ? organisationAuthorityHolder.registrationName
        : null,
    addressRegisteredOfficePlaceHolder: addressRegisteredOfficePlaceHolder,
    addressBusinessPlaceholder: addressBusinessPlaceholder,
    addressPostalPlaceholder: addressPostalPlaceholder
  };

  if (searchCriteria?.searchType === commonConsts.OrganisationSearchYincOtherTypeName && searchCriteria?.manualYinc) {
    result = {
      ...result,
      authorityHolderName: null,
      registrationNumber: searchCriteria.registrationNumber,
      registrationName: searchCriteria.organisationName
    };
  }

  return result;
};

const isNewAuhorityHolder = (orgDataInfo) => {
  if (orgDataInfo?.searchCriteria?.manualYinc === true) {
    return true;
  }
  const result = !!!orgDataInfo?.data?.siebelRowId;

  return result;
};

export { getApplicationDetails, getOrgApplicationDetails, getOrgAuthorityHolderDetails, isNewAuhorityHolder };
